import React from 'react';
import { GiftIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function BonusSection() {
  const bonuses = [{
    title: 'Cuaderno del Alfabeto Visual',
    description: 'Actividades visuales para reconocer cada letra.',
    value: 6999,
    image: 'https://cdn.magicpatterns.com/uploads/kRKzAK6bv9CyD23SY4BqnR/task_01kcyw1cp7ed5a2428bea2aqj8_1766267641_img_1.webp'
  }, {
    title: 'Rompecabezas del Alfabeto',
    description: 'Juegos de armado para reforzar el aprendizaje.',
    value: 8999,
    image: 'https://cdn.magicpatterns.com/uploads/jXJmaWae2pKGYtcor2CwV3/task_01kcyx16pbe6k84szw42exxq3n_1766268687_img_1.webp'
  }, {
    title: 'Cuaderno de Formación de Palabras',
    description: 'Ejercicios para construir palabras paso a paso.',
    value: 7999,
    image: 'https://cdn.magicpatterns.com/uploads/5DS4zrEwadCPTJCL6ADsrR/task_01kcyxmb0yevev3bvye4vbf0jm_1766269310_img_0.webp'
  }, {
    title: 'Cuaderno de Trazado del Alfabeto',
    description: 'Práctica de trazado guiado para cada letra.',
    value: 6499,
    image: 'https://cdn.magicpatterns.com/uploads/157wsNgabNAVn1iJR78mwu/task_01kcyy5a1semb833e156bcwasa_1766269867_img_0.webp'
  }, {
    title: 'Alfabeto Emocional',
    description: 'Conecta emociones con letras y palabras.',
    value: 5999,
    image: 'https://cdn.magicpatterns.com/uploads/ezYe3Hw5q3oYn2oBSGdAeN/task_01kcyyk5gheavbecn2vxd1w8ds_1766270323_img_1.webp'
  }, {
    title: 'Planner Semanal de Lectura',
    description: 'Organiza la práctica diaria de forma simple.',
    value: 5999,
    image: 'https://cdn.magicpatterns.com/uploads/2qkqjYdGPbVvSquBgvH6HK/task_01kcz7waf3eh6rmnmk0346cxve_1766280058_img_1_(1).webp'
  }, {
    title: 'Guía Antifrustración para Padres',
    description: 'Estrategias para acompañar sin presionar.',
    value: 8999,
    image: 'https://cdn.magicpatterns.com/uploads/mvCTKABSxuQRneLR4fCBVL/task_01kd0h6479ee4tpbay294c86g9_1766323386_img_1.webp'
  }];
  const formatPrice = (num: number) => {
    return '$' + num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };
  const totalValue = bonuses.reduce((sum, bonus) => sum + bonus.value, 0);
  return <section className="py-8 md:py-20 px-4 bg-gradient-to-b from-background-cream to-white relative overflow-hidden" data-id="element-76">
      <div className="max-w-5xl mx-auto relative z-10" data-id="element-77">
        <FadeIn data-id="element-78">
          <div className="text-center mb-8 md:mb-16" data-id="element-79">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3 md:mb-4 flex items-center justify-center gap-3" data-id="element-80">
              <GiftIcon className="w-6 h-6 text-accent-gold" data-id="element-81" />
              Reclama Estos 7 Bonos Exclusivos
            </h2>
            <div className="w-24 h-1 bg-accent-gold mx-auto rounded-full" data-id="element-82"></div>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 mb-8 md:mb-12" data-id="element-83">
          {bonuses.map((bonus, idx) => <FadeIn key={idx} delay={idx * 0.06} data-id="element-84">
              <div className="bg-white rounded-2xl shadow-sm border border-gray-200 h-full flex flex-col overflow-hidden" data-id="element-85">
                <div className="aspect-[16/10] bg-gradient-to-br from-amber-50 via-orange-50/80 to-yellow-50 flex items-center justify-center relative border-b border-gray-100" data-id="element-86">
                  {bonus.image ? <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover" data-id="element-87" /> : <p className="text-gray-400 font-medium text-xs bg-white/80 backdrop-blur px-3 py-1 rounded-md inline-block border border-gray-100" data-id="element-88">
                      [Imagen del bono]
                    </p>}
                </div>

                <div className="p-4 md:p-8 flex flex-col flex-1 text-center" data-id="element-89">
                  <div className="text-accent-gold font-semibold text-[10px] md:text-xs uppercase tracking-[0.2em] mb-2 md:mb-3" data-id="element-90">
                    BONO #{idx + 1}:
                  </div>
                  <h3 className="text-base md:text-xl font-semibold text-gray-900 mb-1.5 md:mb-2 leading-snug" data-id="element-91">
                    {bonus.title}
                  </h3>
                  <p className="text-gray-500 text-xs md:text-sm leading-relaxed mb-4 md:mb-6 flex-1" data-id="element-92">
                    {bonus.description}
                  </p>
                  <div className="pt-3 md:pt-4 border-t border-gray-100" data-id="element-93">
                    <div className="text-gray-400 line-through text-sm md:text-base font-medium mb-0.5 md:mb-1" data-id="element-94">
                      {formatPrice(bonus.value)} ARS
                    </div>
                    <div className="text-accent-gold font-bold text-xl md:text-2xl" data-id="element-95">
                      ¡GRATIS!
                    </div>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn data-id="element-96">
          <div className="bg-gradient-to-br from-amber-50 to-orange-50 border border-accent-gold/30 rounded-2xl p-6 md:p-10 text-center relative overflow-hidden shadow-sm" data-id="element-97">
            <h3 className="text-sm font-semibold text-accent-gold mb-2 uppercase tracking-wider" data-id="element-98">
              Valor Total de los Bonos
            </h3>
            <div className="mb-4 md:mb-6" data-id="element-99">
              <span className="text-xl md:text-3xl font-bold text-gray-400 line-through" data-id="element-100">
                $51.493 ARS
              </span>
            </div>
            <div className="inline-block bg-accent-gold text-white font-semibold text-sm md:text-base px-6 py-3 rounded-lg" data-id="element-101">
              HOY LOS RECIBES GRATIS
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}